import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ThemeProvider } from 'next-themes';
import App from './App';
import './index.css';
// Public marketing pages' scoped design system (.scene) — must load after Tailwind.
import './styles/scene.css';
import './i18n/config';
// import { datadogRum } from '@datadog/browser-rum';
// import { datadogLogs } from '@datadog/browser-logs';

// Initialize Datadog RUM (Real User Monitoring)
// if (import.meta.env.VITE_DATADOG_APPLICATION_ID && import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
//   try {
//     datadogRum.init({
//       applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
//       clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
//       site: import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com',
//       service: import.meta.env.VITE_DATADOG_SERVICE || 'targetna-frontend',
//       env: import.meta.env.VITE_DATADOG_ENV || 'production',
//       version: '1.0.0',
//       sessionSampleRate: 100,
//       sessionReplaySampleRate: 20,
//       trackUserInteractions: true,
//       trackResources: true,
//       trackLongTasks: true,
//       trackBfcacheViews: true,
//       defaultPrivacyLevel: 'mask-user-input',
//     });

//     datadogLogs.init({
//       clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
//       site: import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com',
//       forwardErrorsToLogs: true,
//       sessionSampleRate: 100,
//     });

//     console.log('✅ Datadog RUM initialized');
//   } catch (error) {
//     console.warn('⚠️ Datadog RUM initialization failed:', error);
//   }
// } else {
//   console.log('ℹ️ Datadog RUM not configured (missing env vars)');
// }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="light">
        <TooltipProvider>
          <BrowserRouter>
            <App />
            <Toaster />
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
